import {
  Snackbar as MuiSnackbar,
  SnackbarContent as MuiSnackbarContent,
  type SnackbarContentProps as MuiSnackbarContentProps,
  type SnackbarProps as MuiSnackbarProps,
} from '@mui/material'

export type SnackbarProps = MuiSnackbarProps
export type SnackbarContentProps = MuiSnackbarContentProps

export const Snackbar = MuiSnackbar
export const SnackbarContent = MuiSnackbarContent
